export default "__VITE_ASSET__CDlHTpR5__";